import { render, staticRenderFns } from "./pivots-chart.component.vue?vue&type=template&id=9c908760&scoped=true"
import script from "./pivots-chart.component.vue?vue&type=script&lang=ts"
export * from "./pivots-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./pivots-chart.component.vue?vue&type=style&index=0&id=9c908760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c908760",
  null
  
)

export default component.exports